<template>
  <App>
    <AppBar>
      <div class="flex-wrap">
        <BaseIcon :icon="displayFlow.icon || 'lianjieliu'" size="18" style="margin-right:5px" />
        <FlowFileName v-model="displayFlow" />
        <span v-if="displayFlow.status" style="font-size:12px;color:var(--subtext2);margin-left:8px;">{{ displayFlow.status }}</span>
        <Button icon="md-refresh" @click="getData()" size="small" style="margin-left:10px" :loading="loading" />
      </div>
      <div class="flex-wrap" />
      <div class="flex-wrap split5">
        <AppAvatar />
      </div>
    </AppBar>

    <AppMask title="工作流程" icon-right="lianjieliu" :loading="bootLoading" />
    <AppClient>
      <div v-if="loadError" class="flow-instance-page-error">
        <BaseEmpty :msg="loadError" />
        <div style="text-align:center;margin-top:12px;">
          <Button type="primary" @click="getData()">重新加载</Button>
        </div>
      </div>
      <FlowInstance
        v-else-if="flow && flow.id"
        :key="flow.id"
        :flow="flow"
        :version="flow.version || {}"
        @loaded="onInstanceLoaded"
      />
      <div v-else class="flow-instance-page-boot">
        <BaseSkeletonLoading variant="form" />
        <BaseSkeletonLoading variant="panel" style="margin-top:12px;max-width:360px;" />
      </div>
    </AppClient>
  </App>
</template>

<script>
import responsableMixin from '@/mixins/responsable';
import {mapGetters} from 'vuex';
import App from '@/components/app/app';
import AppBar from '@/components/app/bar';
import AppMask from '@/components/app/mask-loading';
import AppClient from '@/components/app/client';
import AppAvatar from '@/components/app/avatar';
import FlowFileName from '@/components/flow/app/filename';
import FlowInstance from '@/components/flow/instance';
export default {
  components: {App, AppBar, AppClient, AppAvatar, FlowFileName, FlowInstance, AppMask},
  routerOption: {
    as_default: true,
  },
  data() {
    return {
      loading: false,
      bootLoading: true,
      loadError: '',
      flow: null,
      reqSeq: 0,
    };
  },
  mixins: [responsableMixin],
  watch: {
    $route: {
      handler(r, o) {
        if (!o || r.params.id !== o.params.id) {
          this.flow = null;
          this.loadError = '';
          this.bootLoading = true;
          this.getData();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapGetters('session', ['session']),
    id() {
      return this.$route.params.id;
    },
    displayFlow() {
      if (this.flow && this.flow.id) {
        return {
          name: this.flow.name || '流程实例',
          icon: this.flow.icon,
          status: this.flow.status,
        };
      }
      return {name: '流程实例'};
    },
  },
  methods: {
    getData() {
      if (!this.id) return;
      const seq = ++this.reqSeq;
      this.loading = true;
      this.bootLoading = true;
      this.loadError = '';
      this.$api.get(`/oa/flow-instances/${this.id}`).then((res)=>{
        if (seq !== this.reqSeq) return;
        const data = res.data.data || null;
        if (!data || !data.id) {
          this.loadError = '未找到流程实例';
          this.flow = null;
          return;
        }
        this.flow = data;
      }).catch((e)=>{
        if (seq !== this.reqSeq) return;
        this.flow = null;
        this.loadError = (e && (e.message || e.msg || e)) || '加载失败';
        this.Error(e);
      }).finally(()=>{
        if (seq !== this.reqSeq) return;
        this.loading = false;
        this.bootLoading = false;
      });
    },
    onInstanceLoaded(data) {
      if (data && data.id) {
        this.flow = data;
      }
    },
  },
};
</script>

<style lang="less">
.flow-instance-page-boot,
.flow-instance-page-error {
  padding: 16px 20px;
  height: 100%;
  box-sizing: border-box;
}
</style>
